import React, { memo } from 'react';
import './DashboardBackground.css';

const DashboardBackground = memo(() => (
  <div className="dashboard-bg" aria-hidden="true">
    <div className="dashboard-bg__base" />
    <div className="dashboard-bg__orb dashboard-bg__orb--1" />
    <div className="dashboard-bg__orb dashboard-bg__orb--2" />
    <div className="dashboard-bg__orb dashboard-bg__orb--3" />
    <div className="dashboard-bg__grid" />
    <div className="dashboard-bg__vignette" />
  </div>
));

export default DashboardBackground;
